import { render, staticRenderFns } from "./BatchCreateMultiLang.vue?vue&type=template&id=8b24a894&scoped=true&"
import script from "./BatchCreateMultiLang.vue?vue&type=script&lang=js&"
export * from "./BatchCreateMultiLang.vue?vue&type=script&lang=js&"
import style0 from "./BatchCreateMultiLang.vue?vue&type=style&index=0&id=8b24a894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b24a894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
